import { Evaluation } from '../types.d'
import getLayer from './get-layer'

const getRequestLayer = (
  ctx: Evaluation.Ctx,
): Evaluation.CtxRequestLayer | null =>
  getLayer(ctx, 'RequestLayer') as Evaluation.CtxRequestLayer | null

export default getRequestLayer
